import { render, staticRenderFns } from "./ThemeLandscape.vue?vue&type=template&id=70a917e5&scoped=true&"
import script from "./ThemeLandscape.vue?vue&type=script&lang=js&"
export * from "./ThemeLandscape.vue?vue&type=script&lang=js&"
import style0 from "./ThemeLandscape.vue?vue&type=style&index=0&id=70a917e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a917e5",
  null
  
)

export default component.exports